import {Box, Tab, Tabs} from '@mui/material';
import {Link, useMatch} from 'react-router-dom';
import React, {ReactElement} from 'react';
import {ANNUAL_REVIEWS_NEW} from '../../../constants/Routes';

interface NavTabsProps {
  tabs: {
    href: string;
    label: string;
    icon: ReactElement;
  }[];
  rightTabs?: {
    href: string;
    label: string;
    icon: React.ReactElement;
  }[];
  children?: React.ReactNode;
}

const NavTabs: React.FC<NavTabsProps> = ({tabs, rightTabs, children}) => {
  const match = useMatch(`/${ANNUAL_REVIEWS_NEW}/:filter/:reviewId?`);

  return (
    <Box
      sx={{
        borderBottom: 1,
        borderColor: 'divider',
        marginBottom: 2,
      }}
    >
      <Tabs value={match?.params.filter} variant="scrollable" scrollButtons="auto">
        {tabs.map(({href, label, icon}) => (
          <Tab
            key={href}
            label={
              <Box sx={{alignItems: 'center', display: 'flex', gap: 1}}>
                {icon}
                {label}
              </Box>
            }
            component={Link}
            to={`/${ANNUAL_REVIEWS_NEW}/${href}`}
            value={href}
          />
        ))}
        {children}
        {rightTabs?.map(({href, label, icon}) => (
          <Tab
            sx={{ml: 'auto'}}
            key={href}
            label={
              <Box sx={{alignItems: 'center', display: 'flex', gap: 1}}>
                {icon}
                {label}
              </Box>
            }
            component={Link}
            to={`/${ANNUAL_REVIEWS_NEW}/${href}`}
            value={href}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default NavTabs;
